<div class="team-reduction-dialog">
  <!-- Header -->
  <div class="flex items-start sm:items-center justify-between !px-4 !py-3 sm:!py-2 border-b border-slate-100 gap-3">
    <h2 mat-dialog-title class="!m-0 !p-0 text-[18px] font-bold text-slate-800 leading-tight flex-1">
      <span>Your plan allows fewer teams</span>
    </h2>
    <button mat-icon-button class="text-slate-400 hover:text-slate-600 transition-colors shrink-0 -mt-1 sm:mt-0"
      (click)="onCancel()" aria-label="Close dialog" [disabled]="deleting">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content min-h-[300px]">

    <div class="flex flex-col mb-4 !max-w-[480px] !min-w-[320px]">
      <div *ngIf="loading" class="flex flex-col items-center justify-center py-12">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="text-slate-500 mt-4 font-medium text-[14px]">Loading teams...</p>
      </div>

      <div *ngIf="deleting" class="flex flex-col items-center justify-center py-12 gap-4">
        <mat-spinner diameter="42"></mat-spinner>
        <p class="text-[15px] font-medium text-slate-700 m-0">Deleting selected team…</p>
      </div>

      <ng-container *ngIf="!loading && !deleting">
        <!-- Warning box like hidden-to-general -->
        <div class="flex-col p-4 rounded-xl mb-5 bg-[#fffbeb] border border-solid border-[#fde68a] shadow-sm">
          <div class="flex gap-3 items-start w-full">
            <mat-icon class="text-[#d97706] shrink-0 mt-0.5">info</mat-icon>
            <div class="flex flex-col gap-1.5">
              <p class="text-[#92400e] text-[14px] font-medium !mb-0 !mt-0 leading-snug tracking-[inherit]">
                Deleting a team here only removes the team. <strong>Employees stay in your workspace.</strong>
              </p>
            </div>
          </div>
        </div>
        <p class="text-[13.5px] text-slate-500 !mb-3 !mt-0 leading-relaxed">
          Reduce your team count to meet plan limits.
        </p>

        <div *ngIf="teams.length === 0" class="flex flex-col items-center justify-center py-10 gap-2 text-slate-500">
          <mat-icon class="!text-[32px] !w-[32px] !h-[32px] text-slate-300">group_off</mat-icon>
          <p class="m-0 text-[14px]">No teams found.</p>
        </div>

        <!-- Affected employees style for teams list -->
        <div class="flex flex-col gap-2 mb-2" *ngIf="teams.length > 0">
          <p class="text-[13.5px] font-medium text-slate-600 !m-0">Available teams ({{ teams.length }})</p>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 overflow-y-auto max-h-[180px] pr-1">
            <label
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg border border-solid transition-all cursor-pointer group"
              [class.border-indigo-500]="selectedTeamToDelete === team.id"
              [class.bg-indigo-50]="selectedTeamToDelete === team.id"
              [class.border-[#e5e7eb]]]="selectedTeamToDelete !== team.id"
              [class.bg-[#f6f7f9]]]="selectedTeamToDelete !== team.id"
              [class.hover:border-gray-300]="selectedTeamToDelete !== team.id" *ngFor="let team of teams"
              (click)="onSelectTeamToDelete(team.id)">
              <mat-radio-button class="shrink-0 pointer-events-none custom-radio" [value]="team.id"
                [checked]="selectedTeamToDelete === team.id" color="primary">
              </mat-radio-button>
              <div
                class="flex-shrink-0 flex items-center justify-center rounded-full overflow-hidden w-[32px] h-[32px]">
                <ngx-avatars name="{{ team.title.rendered }}" size="32" initialsSize="2"></ngx-avatars>
              </div>
              <div class="flex flex-col flex-1 overflow-hidden pl-1">
                <p class="!text-[13.5px] font-medium text-slate-700 truncate m-0 leading-tight"
                  [innerHTML]="team.title.rendered"></p>
                <p class="!text-[12px] text-slate-500 m-0 leading-tight mt-0.5">{{ getMemberCount(team) }} member{{
                  getMemberCount(team) === 1 ? '' : 's' }}</p>
              </div>
            </label>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="flex flex-col-reverse sm:flex-row w-full justify-center sm:!justify-end gap-3 pt-4 pb-2 border-t border-slate-100 mt-2 !mb-0 px-4">

    <button mat-stroked-button type="button" class="action-secondary w-full sm:w-auto min-h-[40px] !m-0"
      (click)="onCancel()" [disabled]="deleting">Cancel</button>
    <button mat-raised-button color="primary" type="button" class="action-primary w-full sm:w-auto min-h-[40px] !m-0"
      [disabled]="!selectedTeamToDelete || deleting" (click)="onDeleteTeam()">
      <span *ngIf="!deleting">Delete Selected Team</span>
      <span *ngIf="deleting" class="flex items-center gap-2">
        <mat-spinner diameter="20"></mat-spinner>
        Deleting...
      </span>
    </button>

  </mat-dialog-actions>
</div>